import Button from "@mui/material/Button";
import { Box, Grid, Stack } from "@mui/system";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Alert,
} from "@mui/material";

import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CreateInput from "./CreateInput";
import {
  handleChangeHelper,
  handleFormatHelper,
} from "../../DataStoreHelpers/dataStoreHelpers";
import { useDispatch } from "react-redux";
import { setCreateQueryFormData } from "../../../../../features/dataStoreReqSlice";
import { useSelector } from "react-redux";
import Editor from "react-simple-code-editor";
import Prism from "prismjs";
import "prismjs/components/prism-sql"; // load SQL syntax
import "prismjs/themes/prism.css"; // or your theme

const CreateOutputError = () => {
  const dispatch = useDispatch();
  const formData = useSelector(
    (state: any) => state.dataStoreReq.createQueryFormData
  );

  const handleChange = (key: string, value: any) => {
    handleChangeHelper(dispatch, setCreateQueryFormData, key, value);
  };

  const handleFormat = () => {
    handleFormatHelper(formData.requestSql, (updatedSql) => {
      handleChange("requestSql", updatedSql);
    });
  };
  const { hasError, hasErrorMessage } = useSelector(
    (state: any) => state.dataStoreReq
  );
  return (
    <>
      <Stack
        flexDirection={"row"}
        alignItems={"center"}
        mt={4}
        border={"rgba(237, 108, 2, 0.5) 1px solid"}
        padding={"8px 8px 8px 16px"}
        borderRadius={"4px"}
        sx={{ backgroundColor: "rgba(253, 237, 237, 1)" }}
      >
        <ErrorOutlineIcon
          fontSize="small"
          sx={{ marginRight: "8px", color: "rgba(211, 47, 47, 1)" }}
        />
        <Box>
          <Typography
            variant="body1"
            fontWeight="500"
            sx={{ marginBottom: "4px" }}
            color="rgba(95, 33, 32, 1)"
          >
            Something went wrong. Please check your inputs and SQL query for
            errors, then try again.
          </Typography>
          <Typography variant="body2" color="rgba(95, 33, 32, 1)">
            (Error Code: {hasErrorMessage?.status}){" "}
            <a
              href="https://bigquery.googleapis.com/bigquery/v2/projects/reporting-data-base/queries?prettyPrint=false"
              style={{ color: "rgba(156, 39, 176, 1)" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              https://bigquery.googleapis.com/bigquery/v2/projects/reporting-data-base/queries?prettyPrint=false
            </a>
            <br />
            {hasErrorMessage?.text}
          </Typography>
        </Box>
      </Stack>
      <Box mt={2}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography component="span">SQL Quarry</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid size={12}>
              <div
                style={{
                  position: "relative",
                  display: "inline-block",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-8px",
                    left: "8px",
                    background: "#f5f5f5",
                    padding: "2px 6px",
                    fontSize: "12px",
                    borderRadius: "4px",
                    zIndex: 1,
                  }}
                >
                  Request SQL
                </div>

                <Box
                  sx={{
                    height: "200px", // Set fixed height here
                    minHeight: "300px", // cannot go smaller than this
                    width: "100%", // always full width
                    resize: "vertical", // only allow vertical resize
                    overflow: "auto", // enable scrolling
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                >
                  <Editor
                    value={formData.requestSql}
                    onValueChange={(val) => handleChange("requestSql", val)}
                    highlight={(code) =>
                      Prism.highlight(code, Prism.languages.sql, "sql")
                    }
                    padding={10}
                    style={{
                      fontFamily: '"Fira code", "Fira Mono", monospace',
                      fontSize: 14,
                      minHeight: "100%", // Make sure editor fills container
                      whiteSpace: "pre-wrap",
                      wordWrap: "break-word",
                    }}
                  />
                </Box>
                {hasError && (
                  <Alert severity="error" sx={{ mt: 2 }}>
                    Something went wrong. Please check your inputs and SQL query
                    for errors, then try again.
                  </Alert>
                )}
              </div>

              <Stack spacing={1} direction="row" mt={1}>
                <Stack>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "12px" }}
                    color="#00000099"
                  >
                    Do not use snippets or comments in the SQL syntax. Do not
                    use constructions like FORMAT(\“%d\“,
                    CAST(floor(additional_2)) (or other constructions using
                    \“%d\")).
                  </Typography>
                </Stack>
                <Button
                  color="secondary"
                  variant="outlined"
                  endIcon={<FormatListNumberedIcon />}
                  onClick={handleFormat}
                >
                  Format
                </Button>
              </Stack>
              <Typography
                variant="body2"
                sx={{ fontSize: "12px" }}
                color="#00000099"
                mt={2}
              >
                All fields are mandatory.
              </Typography>
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <Typography component="span">Input Fields</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <CreateInput />
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
};

export default CreateOutputError;
